import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { getCursor } from '../utils/update.utils';

export const updateSelector = ({ update }: DefaultRootState) => update;

export const idSelector = createSelector(updateSelector, ({ id }) => id);

export const isUpdatingSelector = createSelector(
  idSelector,
  (id) => id != null,
);

export const getWaveCursorSelector = createSelector(updateSelector, (update) =>
  getCursor(update.updateMode),
);
